import React from "react";
import "./../styles/underline_title.style.css";

export default function UnderlineTitle({ title = "" }) {
  return <h2 className="underline-title">{title}</h2>;
}
